<style lang="stylus">
.id_verify {
  background-color: #FFC627;
  color: black;
  padding: 1.15rem 1rem !important;
  border-radius: 8px 8px 0px 0px;
}

/* Override v-row padding specifically within id_verify */
.id_verify .v-row {
  padding: 0 !important;
  margin: 0 !important;
}

.link {
  color: black !important;
  font-weight: 500;
  border-bottom: 2px solid #fdc63b;
}

.white-border-wrapper {
  border-left: 1px solid #d0d0d0;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
  border-radius: 0px 0px 8px 8px;
  padding: 1rem;
  width: 100%;
}


.content-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #333;
  margin-bottom: 1rem;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.button-container {
  margin-top: 1rem;
}

.icon-col {
  padding-right: 16px;
}

.text-col {
  flex: 1;
}
</style>
<template>
  <div class="wrap mt-8 mt-md-0" v-if="isvalidVerificationStatus">
    <v-row class="id_verify" align="center">
      <v-col cols="auto" class="icon-col">
        <v-icon style="font-size: 2.5rem; font-weight: 300" class="far fa-id-card" />
      </v-col>
      <v-col class="text-col">
        <p style="font-weight: 400; font-size: 14px; margin: 0 0 -2px 20px">Identity verification</p>

        <div style="display: flex; align-items: center; gap: 8px">
          <span style="font-weight: 500; font-size: 21px; margin: 0 0 0 20px" v-if="!idVerify"> Not Verified </span>
          <span
            style="font-weight: 500; font-size: 21px; margin: 0 0 0 20px"
            v-else-if="shouldDisplayIdVerifyForVerified && idVerify == 'approved'"
          >
            Verified
          </span>
          <span style="font-weight: 500; font-size: 21px; margin: 0 0 0 20px" v-else-if="idVerify == 'submitted'">
            Under Review
          </span>
          <span style="font-weight: 500; font-size: 21px; margin: 0 0 0 20px" v-else-if="idVerify == 'denied'">
            Verification Failed
          </span>

          <v-icon
            v-if="idVerify === null || idVerify === '' || idVerify === 'denied'"
            color="black"
            style="font-size: 18px; margin-bottom: 2px"
            class="fas fa-exclamation-triangle"
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <div class="white-border-wrapper mb-8">
        <v-col cols="12" class="verification-content">
          <div class="content-text">
            <span v-if="shouldDisplayIdVerifyForVerified && idVerify == 'approved'">
              Congratulations, your ID Verification was successful.
            </span>
            <span v-else-if="idVerify == null || idVerify == ''">
              Before you can pursue any courses for credit, you must verify your identity with a photo of yourself and a
              government-issued ID. You only have to verify once ever.
            </span>
            <span v-else-if="idVerify == 'submitted'">
              Your ID is in the process of being verified. Check back in 2-3 business days to ensure that your
              verification was successful.
            </span>
            <span v-else-if="idVerify == 'denied'">
              {{ idVerificationDeniedMessage }}
              <br /><br />
              <router-link to="/id-verification" style="color: black" class="link">
                <strong>Click here</strong> </router-link
              >&nbsp;to try again.
            </span>
          </div>

          <div v-if="!idVerify" class="button-container">
            <router-link to="/id-verification" style="text-decoration: none">
              <UiButton variant="gold" size="medium" @click="asuoDataLayerClick('idVerifyBox', '0')">
                Verify your identity
              </UiButton>
            </router-link>
          </div>
        </v-col>
      </div>
    </v-row>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { useUserStore } from '@/stores/user';
import { Button as UiButton } from './ui/index.js';

export default defineComponent({
  name: 'VerificationStatusComponent',
  components: {
    UiButton
  },

  data() {
    return {};
  },

  computed: {
    verifyLink() {
      return import.meta.env.VITE_VERIFICATION;
    },
    idVerify() {
      const userStore = useUserStore();
      return userStore.apis?.learnerData?._idVerify;
    },
    idVerificationDeniedMessage() {
      const userStore = useUserStore();
      return userStore.apis?.learnerData?._idVerificationDeniedMessage;
    },
    isvalidVerificationStatus() {
      return (
        !this.idVerify ||
        this.idVerify == null ||
        this.idVerify === 'denied' ||
        (this.idVerify === 'approved' && this.shouldDisplayIdVerifyForVerified) ||
        this.idVerify === 'submitted'
      );
    },
    shouldDisplayIdVerifyForVerified() {
      const userStore = useUserStore();
      return new Date(userStore.apis?.learnerData?._idVerificationPortalExpiration) > new Date();
    }
  },

  mixins: [DataLayerMixin]
});
</script>
